// @ts-nocheck

export function readFileAsDataURL(file) {
  return new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = (e) => res(e.target.result);
    r.onerror = (e) => rej(e);
    r.readAsDataURL(file);
  });
}

function drawScaled(img, maxW) {
  let w = img.width,
    h = img.height;
  if (w > maxW) {
    h = Math.round((h * maxW) / w);
    w = maxW;
  }
  if (h > maxW) {
    w = Math.round((w * maxW) / h);
    h = maxW;
  }
  const c = document.createElement("canvas");
  c.width = w;
  c.height = h;
  c.getContext("2d").drawImage(img, 0, 0, w, h);
  return c;
}

function loadImage(src) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.onload = () => res(img);
    img.onerror = () => rej(new Error("Image load failed"));
    img.src = src;
  });
}

export function compressImage(dataURL, maxW = 800, quality = 0.8) {
  return loadImage(dataURL).then((img) => drawScaled(img, maxW).toDataURL("image/jpeg", quality));
}

// Variante che produce un Blob, adatta per upload diretto su GCS via signed URL.
export async function compressImageToBlob(file, maxW = 800, quality = 0.8) {
  const dataUrl = await readFileAsDataURL(file);
  const img = await loadImage(dataUrl);
  const canvas = drawScaled(img, maxW);
  return new Promise((res, rej) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) return rej(new Error("Canvas toBlob returned null"));
        res(blob);
      },
      "image/jpeg",
      quality,
    );
  });
}
